module.exports = __webpack_public_path__ + "assets/icons/completed-jobs-reverse.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/sidemenu/completed-jobs-reverse.png
// module id = ./src/styles/icons/sidemenu/completed-jobs-reverse.png
// module chunks = 0